import * as React from "react"
import { Context } from "@contexts/AuthCtx.tsx"

const useAuthCtx = () => React.useContext(Context)

export default useAuthCtx
